import { getPartnerParam } from './getPartnerParam';
import { isFeatureEnabled } from 'owa-feature-flags';
import { getQueryStringParameter } from 'owa-querystring';

let debugHook: { [paramName: string]: string } = null;
const debugHookParamName = 'searchtesthook';
function getDebugHook(): { [paramName: string]: string } {
    if (!debugHook) {
        debugHook = {};
        const debugHookURIString = getQueryStringParameter(debugHookParamName);
        const debugHookString = decodeURIComponent(debugHookURIString || '').trim();

        if (isFeatureEnabled('sea-debugHook') && debugHookString.length > 0) {
            // the searchtesthook query param takes the form of a string of more query params which we want
            // to use as overrides on our 3S requests. To that end, we turn the debugHook value into a
            // dictionary
            const debugHookKeyValuePairStrings = debugHookString.split('&');
            debugHook = debugHookKeyValuePairStrings.reduce((acc, e) => {
                const [key, value] = e.split('=');
                acc[key] = value;
                return acc;
            }, {});
        }
    }

    return debugHook;
}

export default function buildQueryParams(defaultQueryParams: { [key: string]: string } = {}) {
    const params = { ...defaultQueryParams, ...getDebugHook(), ...getPartnerParam() };

    const filtered = Object.keys(params)
        .filter(key => params[key] !== null)
        .reduce((obj, key) => {
            return {
                ...obj,
                [key]: params[key],
            };
        }, {});

    return filtered;
}
